import {CCol, CRow} from '@coreui/react-pro';
import React, {lazy, Suspense} from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';

const Breadcrumb = lazy(() => import('../components/helper/Breadcrumb'));
const RealEstateManagementsCard = lazy(() => import('../components/real-estate-management/overview/Card'));

function RealEstateManagementsPage({t} : WithTranslation) {
    return (
        <>
            <Breadcrumb items={[
                {
                    name: t('real-estate-managements:page.breadcrumb.real-estate-managements', '~Übersicht Immobilienverwaltungen'),
                    active: true
                }
            ]}/>
            <CRow>
                <CCol xl={8} xxl={7}>
                    <Suspense fallback={<></>}><RealEstateManagementsCard/></Suspense>
                </CCol>
            </CRow>
        </>
    );
}

export default withTranslation(['real-estate-managements'])(RealEstateManagementsPage);
